import { render } from "./ShortcutLink.vue?vue&type=template&id=7c5e5764"
import script from "./ShortcutLink.vue?vue&type=script&lang=js"
export * from "./ShortcutLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__